import { useState } from "react";
import { api } from "../api.js";
import { useAuth } from "../auth.jsx";
import { ErrorBox, SuccessBox, fmtDate, CopyButton } from "../components/helpers.jsx";

export default function Settings() {
    const { me, refresh } = useAuth();
    const [err, setErr] = useState(null);
    const [msg, setMsg] = useState(null);

    const [newPass, setNewPass]   = useState("");
    const [newPass2, setNewPass2] = useState("");

    async function rotateKey() {
        if (!confirm("Rotate your API key? Any upstream server still using the old key will start getting 401s.")) return;
        setErr(null); setMsg(null);
        try {
            await api.post("/api/admin/me/api-key/rotate");
            await refresh();
            setMsg("API key rotated.");
        } catch (e) { setErr(e.message); }
    }

    async function changePass(e) {
        e.preventDefault();
        if (newPass !== newPass2) { setErr("passwords don't match"); return; }
        if (newPass.length < 8)   { setErr("password must be at least 8 chars"); return; }
        setErr(null); setMsg(null);
        try {
            await api.post("/api/admin/me/password", { password: newPass });
            setMsg("Password changed.");
            setNewPass(""); setNewPass2("");
        } catch (e) { setErr(e.message); }
    }

    if (!me) return null;

    return (
        <>
            <div className="page-header">
                <div>
                    <h1>Settings</h1>
                    <div className="sub">Your account &amp; API key.</div>
                </div>
            </div>

            <ErrorBox>{err}</ErrorBox>
            <SuccessBox>{msg}</SuccessBox>

            <div className="card">
                <h2>Account</h2>
                <table className="data">
                    <tbody>
                        <tr><th>Username</th><td className="mono">{me.username}</td></tr>
                        <tr><th>Role</th><td><span className={`pill role${me.role === "super" ? " super" : ""}`}>{me.role}</span></td></tr>
                        <tr><th>Created</th><td>{fmtDate(me.createdAt)}</td></tr>
                    </tbody>
                </table>
            </div>

            <div className="card" style={{ marginTop: 12 }}>
                <h2>API key</h2>
                <p className="text-dim" style={{ margin: "4px 0 12px" }}>
                    Send this on every request from your upstream server as <code>x-api-key</code>.
                    Anyone with this key can submit telemetry attributed to your tenant — keep it private.
                </p>
                <div className="copy-row">
                    <div className="mono">{me.apiKey}</div>
                    <CopyButton text={me.apiKey} />
                    <button className="danger" onClick={rotateKey}>Rotate</button>
                </div>
                <div className="text-dim" style={{ marginTop: 8, fontSize: 12 }}>
                    Last rotated {fmtDate(me.apiKeyCreatedAt)}
                </div>
            </div>

            <div className="card" style={{ marginTop: 12 }}>
                <h2>Change password</h2>
                <form onSubmit={changePass} style={{ maxWidth: 360, display: "flex", flexDirection: "column", gap: 10, marginTop: 6 }}>
                    <div>
                        <label>New password</label>
                        <input type="password" value={newPass} onChange={(e) => setNewPass(e.target.value)} />
                    </div>
                    <div>
                        <label>Confirm</label>
                        <input type="password" value={newPass2} onChange={(e) => setNewPass2(e.target.value)} />
                    </div>
                    <div>
                        <button className="primary" type="submit" disabled={!newPass || !newPass2}>Update password</button>
                    </div>
                </form>
            </div>

            <div className="card" style={{ marginTop: 12 }}>
                <h2>Integration example</h2>
                <pre className="json-block">{`POST /api/v1/process
x-api-key: ${me.apiKey}
content-type: application/json

{
  "subject":  "<user id or launch token>",
  "hwid":     "<bcd hash, optional>",
  "endpoint": "product" | "recheck",
  "telemetry": { ... }
}`}</pre>
            </div>
        </>
    );
}
